import {
  HTTP_USERAUTH_FETCHING,
  HTTP_USERAUTH_SUCCESS,
  HTTP_USERAUTH_FAILED,
  HTTP_USERAUTH_CLEAR,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";

export const setStateUserauthToFetching = () => ({
  type: HTTP_USERAUTH_FETCHING,
});

export const setStateClearCountries = () => ({
  type: HTTP_USERAUTH_CLEAR,
});

export const setStateUserauthToSuccess = (payload) => ({
  type: HTTP_USERAUTH_SUCCESS,
  payload,
});

export const setStateUserauthToFailed = () => ({
  type: HTTP_USERAUTH_FAILED,
});

export const getUserauth = (accname) => {
  const accuser = accname;
  return async (dispatch) => {
    dispatch(setStateUserauthToFetching());
    try {
      const result = await httpClient.get(`/authen/countries/${accuser}`);
      dispatch(setStateUserauthToSuccess(result.data));
    } catch (error) {
      dispatch(setStateUserauthToFailed());
    }
  };
};
